import type { Options } from 'ky'
import type { GetMyBookingDetailParams } from '@/schemas/my-booking'
import type {
  DeleteMyBookingResponse,
  GetMyBookingDetailResponse,
  GetMyBookingsResponse,
  GetTabListResponse,
} from '@/types/my-booking'
import { httpClient } from '@/utils/http'

export const myBookingService = {
  allBookings: (options?: Options) =>
    httpClient.get('my_bookings', options).json<GetMyBookingsResponse>(),
  detail: (payload: GetMyBookingDetailParams, options?: Options) =>
    httpClient
      .get(`bookings/${payload.id}/detail`, options)
      .json<GetMyBookingDetailResponse>(),
  delete: (payload: GetMyBookingDetailParams, options?: Options) =>
    httpClient
      .delete(`bookings/${payload.id}`, options)
      .json<DeleteMyBookingResponse>(),
  tabList: (options?: Options) =>
    httpClient.get(`my_bookings/tab_lists`, options).json<GetTabListResponse>(),
}
